import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookie_consent')) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
        background: '#1e293b', borderTop: '1px solid #334155',
        padding: '14px 16px',
      }}
      data-testid="cookie-banner"
    >
      <div style={{ maxWidth: 960, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
        <p style={{ color: '#cbd5e1', fontSize: 13, margin: 0, flex: '1 1 300px', lineHeight: 1.5 }}>
          Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Durch die Nutzung unserer Website stimmen Sie der Verwendung von Cookies zu.{' '}
          <Link to="/datenschutz" style={{ color: '#facc15', textDecoration: 'underline' }}>Datenschutz</Link>
        </p>
        <button
          onClick={accept}
          style={{
            background: '#ca8a04', color: '#fff', border: 'none', padding: '10px 24px',
            borderRadius: 8, fontWeight: 700, fontSize: 14, cursor: 'pointer', whiteSpace: 'nowrap',
          }}
          data-testid="cookie-accept-btn"
        >
          Akzeptieren
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
